<p-table [value]="lineItems()">
    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let key of lineItemKeys()">{{ columnService.smartTranslateColumn("columns." + key) }}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr>
            <td *ngFor="let key of lineItemKeys()">
                {{ row[key] }}
            </td>
        </tr>
    </ng-template>
</p-table>
